export default __webpack_public_path__ + "static/media/boom.67b9c19b.mp3";